import axios from 'axios';

export default class NotificationService {
  constructor() {
    this.apiUrl = process.env.VUE_APP_API_BASE;
    this.accessToken = localStorage.getItem('accessToken');
  }

  getActive() {
    return axios
      .get(`${this.apiUrl}/notification/activated`, {
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
        },
      });
  }

  list() {
    return axios
      .get(`${this.apiUrl}/notification`, {
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
        },
      });
  }

  create(description, title = null) {
    let body = { description };

    if (title && title.length) {
      body['title'] = title;
    }

    return axios
      .post(`${this.apiUrl}/notification`, body,
        {
        headers: {
          'Authorization': `Bearer ${this.accessToken}`,
        },
      });
  }

  update(id, description, title) {
    let body = { description };

    if (title && title.length) {
      body['title'] = title;
    }

    return axios
      .put(`${this.apiUrl}/notification/${id}`, body,
        {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
          },
        });
  }

  disabledActive() {
    return axios
      .delete(`${this.apiUrl}/notification/activated`,
        {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
          },
        });
  }
}
